import { useEffect } from 'react';
import { Tabs } from 'antd';
import { useParams, Link, useLocation } from 'react-router-dom';
// import { LeftOutlined } from '@ant-design/icons';
import './index.less';
import Judges from './Judges';
import ParticipatingTeam from './ParticipatingTeam';
import PageHeader from '@components/PageHeader/PageHeader';
import { workspaceSelectionReviewsPath } from '@/layouts/selectionWorkspacePaths';
const PersonnelManagement = () => {
    const params = useParams();
    const { pid } = params || 0;
    const location = useLocation();

    useEffect(() => {
        document.title = '人员管理-医评议';
    }, []);

    const onChange = () => {};

    return (
        <>
            <PageHeader breadcrumb={[]}>
                <Link to={workspaceSelectionReviewsPath(pid)} className="back">
                    <i className="bi bi-chevron-left" />
                </Link>
                <span className="current-title">人员管理</span>
                <span className="current-subtitle wrap-subtitle">
                    {location.state?.projectName}
                    <br />
                    {location.state?.stageName}
                </span>
            </PageHeader>

            <div className="page-route-body">
                <div className="tabs-container">
                    <Tabs
                        defaultActiveKey="1"
                        onChange={onChange}
                        items={[
                            {
                                label: `评议专家`,
                                key: '1',
                                children: <Judges />,
                            },
                            {
                                label: `阶段参与人`,
                                key: '2',
                                children: <ParticipatingTeam />,
                            },
                        ]}
                    />
                </div>
            </div>
        </>
    );
};

export default PersonnelManagement;
